import { Box, Group, Text } from "@mantine/core"
import { CheckIcon, PhoneIcon, WarningIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { DeliveryActionButton } from "../delivery/action-controls"
import type { DeliveryActionState } from "../delivery/delivery-actions"
import classes from "./dn-detail.module.css"

const STATUS_TEXT: Record<string, string> = {
  DRAFT: "dnDetail.statusReady",
  ASSIGNED: "dnDetail.statusReady",
  LOADED: "dnDetail.statusLive",
  PENDING_HANDOVER: "dnDetail.statusPendingHandover",
  DELIVERING: "dnDetail.statusLive",
  DELIVERED: "dnDetail.statusDelivered",
  CANCELLED: "dnDetail.statusCancelled",
  RETURNED: "dnDetail.statusReturned",
}

type Props = Readonly<{
  status: string | null | undefined
  notifyState: DeliveryActionState
  onNotify: () => void
  issueState: DeliveryActionState
  completeState: DeliveryActionState
  onIssue: () => void
  onComplete: () => void
}>

/**
 * Sticky bottom bar: status sentence + «Хэрэглэгчид мэдэгдэх» (progress note to the buyer, Ord_DeliveryModals 1), «Гэмтэл, асуудал»,
 * «Хүргэгдсэн гэж тэмдэглэх». Every button reads the delivery action matrix (O86, O88).
 */
export function DnActionBar({ status, notifyState, onNotify, issueState, completeState, onIssue, onComplete }: Props) {
  const { t } = useTranslation("delivery")
  return (
    <Box className={classes.actionBar}>
      <Group justify="space-between" wrap="wrap" gap="sm">
        <Text fz="var(--nw-fz-body)" c="var(--nw-text-2)">
          <Text span fw={700} c="var(--nw-text)">
            {t("dnDetail.statusLabel")}:
          </Text>{" "}
          {t(STATUS_TEXT[status ?? ""] ?? "dnDetail.statusReady")}
        </Text>
        <Group gap="sm">
          <DeliveryActionButton
            state={notifyState}
            variant="default"
            leftSection={<PhoneIcon size={16} />}
            onClick={onNotify}
          >
            {t("dnDetail.notifyCustomer")}
          </DeliveryActionButton>
          <DeliveryActionButton state={issueState} variant="default" leftSection={<WarningIcon size={16} />} onClick={onIssue}>
            {t("dnDetail.reportIssue")}
          </DeliveryActionButton>
          <DeliveryActionButton state={completeState} color="brand" leftSection={<CheckIcon size={16} />} onClick={onComplete}>
            {t("dnDetail.markDelivered")}
          </DeliveryActionButton>
        </Group>
      </Group>
    </Box>
  )
}
